import React, { useEffect, useMemo, useState } from "react";
import apiClient from "../../../utils/apiClient";
import IndexOptionsMuliplierDataTable from "./IndexOptionsMultiplierDataTable";
import { Search, X } from "lucide-react";
import toast from "react-hot-toast"; 
import server from "../../../utils/serverConfig";

export default function IndexptionsMultiplier() {
  const [indexMultiplierData, setIndexMultiplierData] = useState([]);
  const [isIndexDataLoading, setIsIndexDataLoading] = useState(true);
  const [indexSearchTerm, setIndexSearchTerm] = useState('');


  const fetchIndexMultiplierData = () => {
    setIsIndexDataLoading(true);
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-index-multiplier-data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        // Sort data in ascending order before setting state
        const sortedData = [...response.data.data].sort((a, b) => {
          // Assuming you want to sort by clientId (change as needed)
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        setIndexMultiplierData(sortedData);
        setIsIndexDataLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsIndexDataLoading(false);
      });
  };

  const handleEditIndexOptionsConfig = (clientId, payload) => {
    console.log("Client Id", clientId);
    console.log("Updtaed Multipliers Payload data \n\n", payload);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-index-options-multiplier`,
      data: payload,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response.data);

        if (response.data.status === 200) {
          toast.success("Updated Multiplier data Successfully !!", {
            duration: 5000,
          });
        }else{
          toast.error("Failed to Update Multiplier data !!", {
            duration: 5000,
          });
        }

        fetchIndexMultiplierData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchIndexMultiplierData();
  }, []);


  // Add this state for index multiplier search

// Index multiplier search handler
const handleIndexSearch = (searchValue) => {
  setIndexSearchTerm(searchValue);
};


return (
    <div className="flex flex-col relative w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4 w-full">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            Index Options Multiplier
          </p>
          {/* Search Input */}
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-zinc-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Search by Client ID or Name..."
              value={indexSearchTerm}
              onChange={(e) => handleIndexSearch(e.target.value)}
              className="w-full font-medium text-sm pl-10 pr-10 py-1 bg-zinc-700 border border-zinc-600 rounded-lg text-zinc-200 placeholder-zinc-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            {indexSearchTerm && (
              <button
                onClick={() => setIndexSearchTerm('')}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-zinc-400 hover:text-zinc-200 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">
        {isIndexDataLoading ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            loading....
          </div>
        ) : !isIndexDataLoading && indexMultiplierData.length === 0 ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            No Data Found
          </div>
        ) : (
          <div className="flex min-w-full pt-2">
            <IndexOptionsMuliplierDataTable
              indexMultiplierData={indexMultiplierData}
              indexSearchTerm={indexSearchTerm}
              handleEditIndexOptionsConfig={handleEditIndexOptionsConfig}
            />
          </div>
        )}
      </div>
    </div>
  );
}